/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceSprache as AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache } from '../../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-sprache';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IRegisterUserCommand {
  anredeId?: null | string;
  email?: null | string;
  firstname?: null | string;
  lastname?: null | string;
  password?: null | string;
  scope?: null | Array<string>;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
  titel?: null | string;
  titelId?: null | string;
  verificationToken?: null | string;
}
export class RegisterUserCommand extends BaseModel implements IRegisterUserCommand {
  anredeId?: null | string;
  email?: null | string;
  firstname?: null | string;
  lastname?: null | string;
  password?: null | string;
  scope?: null | Array<string>;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
  titel?: null | string;
  titelId?: null | string;
  verificationToken?: null | string;
}

